import { PageLocatorMap } from '../types/PageLocatorMap';

export const loanDocumentUploadAllPage = {
  alert: {
    error: 'loan-document-upload-all-page.form.alert.error',
  },
  footer: {
    root: 'loan-document-upload-all-page.footer.root',
  },
  form: {
    exampleGAPLink: 'loan-document-upload-all-page.form.example-gap-link',
    exampleRICLink: 'loan-document-upload-all-page.form.example-ric-link',
    exampleRoot: 'loan-document-upload-all-page.form.example-root',
    exampleVSCLink: 'loan-document-upload-all-page.form.example-vsc-link',
    h1: 'loan-document-upload-all-page.form.h1',
    h2: 'loan-document-upload-all-page.form.h2',
    root: 'loan-document-upload-all-page.form.root',
    submitButton: 'loan-document-upload-all-page.form.submit-button',
  },
  header: {
    drawerButton: 'loan-document-upload-all-page.header.drawer-button',
    previousStepButton:
      'loan-document-upload-all-page.header.previous-step-button',
    root: 'loan-document-upload-all-page.header.root',
  },
  progress: {
    root: 'loan-document-upload-all-page.progress.root',
  },
} as const satisfies PageLocatorMap;
